import { render, staticRenderFns } from "./AssignFBPComponents.vue?vue&type=template&id=6cda5876&scoped=true"
import script from "./AssignFBPComponents.vue?vue&type=script&lang=js"
export * from "./AssignFBPComponents.vue?vue&type=script&lang=js"
import style0 from "./AssignFBPComponents.vue?vue&type=style&index=0&id=6cda5876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda5876",
  null
  
)

export default component.exports